export default __webpack_public_path__ + "img/2436bdeb52f4d05a0cab8278f9623832.png";